// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2MeLQ","label":"LabeledBox_label__nhrzU"};